import PhaseSixIcon from "../../../basic/phaseSixIcon/PhaseSixIcon";
import { getIsAnswerCorrect, type StudentResultAnswerStates } from "../../../helpers/StudentResultModel";

interface StudentResultAnswerCheckProps {
    state: StudentResultAnswerStates;
}

/**
 * The check beside a correct answer. Never gated by the score reveal: right/wrong is baseline
 * feedback the result always gave. Purely visual — StudentResultAnswerStateLabel carries the verdict
 * for screen readers, for every state.
 */
const StudentResultAnswerCheck = (props: StudentResultAnswerCheckProps) => {
    if (!getIsAnswerCorrect(props.state)) return null;

    return (
        <span
            className="flex items-center shrink-0"
            data-testid="student-result-answer-check"
        >
            <PhaseSixIcon
                name="exercise-ok"
                className="text-xxl text-p6-green"
            />
        </span>
    );
};

export default StudentResultAnswerCheck;
